<template>
  <div>
    <!-- 标题 : 套餐介绍-->
    <div class="title-and-eidt">
      <span class="title">{{ title }}</span>
      <el-link class="edit-button-style"
               v-if="editer_visable_prop"
               @click="editorButtonClick"
               :underline="false"
               type="info"
               icon="el-icon-edit">编辑</el-link>

      <el-link class="save-button-style"
               v-if="save_visable_prop"
               @click="cancleButtonClick"
               :underline="false"
               style="float: right; padding-left: 10px"
               type="info">取消</el-link>

      <el-link class="save-button-style"
               v-if="save_visable_prop"
               @click="saveButtonClick"
               :underline="false"
               style="float: right"
               type="info"
               icon="el-icon-folder-checked">保存</el-link>
    </div>
    <!-- 内容展示 -->
    <span>
      <div v-if="show_content_visable_prop"
           class="edito_save_modify"
           v-html="show_content"></div>
      <!-- 编辑器 -->
      <div class="editor">
        <editor-area @content_change="content_change"
                     v-if="show_editor_prop"
                     :editor_content="editor_content"></editor-area>
      </div>
    </span>
  </div>
</template>

<script>
import Editor from '..//editor/editorV1'

export default {
  name: 'editor-modify',
  components: {
    'editor-area': Editor,
  },
  data() {
    return {
      info: '',
      is_editor: '',
      editer_visable_prop: this.edit_visable,
      save_visable_prop: this.save_visable,
      show_editor_prop: this.show_editor,
      show_content_visable_prop: this.show_content_visable,
      //
      content: this.show_content,
      editor_content: '', //编辑器内容
    }
  },
  props: {
    title: String,
    show_content: String, //动态绑定
    editor_text: String,
    attribuite: Number,
    edit_visable: {
      type: Boolean,
      default: true,
    },
    save_visable: {
      type: Boolean,
      default: false,
    },
    show_editor: {
      type: Boolean,
      default: false,
    },
    show_content_visable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // 复制文本信息pastContent
    pastContent(event) {
      // console.log(event);
      // console.log(event.target);
      this.$copyText(event.target.innerHTML).then((res) => {
        this.$message({
          message: '信息已复制到剪贴板',
          type: 'success',
        })
      })
    },

    // 编辑时的 方法
    editorButtonClick() {
      this.save_visable_prop = true
      this.editer_visable_prop = false
      this.show_editor_prop = true
      this.show_content_visable_prop = false
      this.editor_content = this.show_content
      //   console.log("编辑" + this.editor_content);
      //   this.$emit("change",this.)
    },
    // 保存时的方法
    saveButtonClick() {
      this.save_visable_prop = false
      this.editer_visable_prop = true
      this.show_editor_prop = false
      this.show_content_visable_prop = true
      //   console.log(this.editor_content);
      let sku_id = this.$emit('save', this.editor_content, this.attribuite)
    },
    // 取消编辑
    cancleButtonClick() {
      this.save_visable_prop = false
      this.editer_visable_prop = true
      this.show_editor_prop = false
      this.show_content_visable_prop = true
    },
    // 自定义事件
    saveEvent() {},
    // 监听改变值
    content_change(content) {
      this.editor_content = content
    },

    //  去掉P标签
    removeHtmlStyle(html) {
      var rel = /style\s*?=\s*?([‘"])[\s\S]*?\1/
      var newHtml = ''
      if (html) {
        newHtml = html.replace(rel, '')
      }
      return newHtml
    },
  },
}
</script>

<style>
.title-and-eidt {
  border-left: 5px solid #ff5420;
  padding: 0 5px;
}
.title-and-eidt:hover .edit-button-style {
  display: block;
}

.title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
}
.edito_save_modify {
  /* cursor: pointer; */
  white-space: nowrap;
  margin-top: 5px;
  padding: 0px 10px;
}

.editor {
  margin-top: 10px;
  height: 100%;
}
.edit-button-style {
  display: none;
  float: right;
  font-size: 10px;
}
.save-button-style {
  float: right;
  font-size: 10px;
}
</style>